import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DistributorService } from 'src/app/services/distributor.service';
import * as XLSX from "xlsx";

@Component({
  selector: 'app-washington-gas-users',
  templateUrl: './washington-gas-users.component.html',
  styleUrls: ['./washington-gas-users.component.scss']
})

export class WashingtonGasUsersComponent implements OnInit {

  @ViewChild("TABLE") table: ElementRef;
  dataSource = new MatTableDataSource<any>();
  alldata: any = [];
  displayedColumns: string[] = [
    "GasAccountNumber",
    "GasMeterID",
    "FirstName",
    "LastName",
    "HouseNumberSupplement",
    "PEAddress",
    "City",
    "PostalCode",
    "CountyName",
    "Region",
    "RateCategory"
  ];
  count: number = 0;
  subMenu: string = '';

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  constructor(
    public distributorService: DistributorService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private route: Router
  ) {
    const routeRes = this.route.getCurrentNavigation();
    if (routeRes.extras.state.subMenu)
      this.subMenu = routeRes.extras?.state?.subMenu;
   }

  ngOnInit(): void {
    this.spinner.show();
    this.distributorService.getWashingtonGasUsers().subscribe((data) => {
      this.alldata = data;
      this.dataSource.data = this.alldata;
      this.count = data?.length;
      this.spinner.hide();
    });
  }

  /**
   * formats text to capitalize first letter and lowercase rest
   * @param str 
   */
  formatText(str: string): string {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  ExportTOExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.alldata);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    /* save to file */
    XLSX.writeFile(wb, "WashingtonGasUsersReport.xlsx");
  }

}
